const VisPageError = () => import('@/views/vis-page-error');

export default [
  {
    path: "/error",
    name: "error",
    component: VisPageError,
    props: route => ({ state: route.query.state })
  }
]
